import { render, staticRenderFns } from "./payment-v1.vue?vue&type=template&id=5ad50d0a&scoped=true"
import script from "./payment-v1.vue?vue&type=script&lang=js"
export * from "./payment-v1.vue?vue&type=script&lang=js"
import style0 from "./payment-v1.vue?vue&type=style&index=0&id=5ad50d0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad50d0a",
  null
  
)

export default component.exports